import { Icon } from '@chakra-ui/react'
import type { FC } from 'react'

import { Tooltip } from '@app/components/ui/tooltip'
import ICON_MAP from '@app/utils/iconMap'

interface SharingIconProps {
  sharing: string
}

const SharingIcon: FC<SharingIconProps> = ({ sharing }) => {
  const getShareIcon = () => {
    switch (sharing) {
      case 'private_access':
        return ICON_MAP.SharingPrivate
      case 'public_access':
        return ICON_MAP.SharingPublic
      case 'token_access':
        return ICON_MAP.SharingToken
      default:
        return ICON_MAP.SharingPrivate
    }
  }

  const getShareTooltip = () => {
    switch (sharing) {
      case 'private_access':
        return 'Private access only'
      case 'public_access':
        return 'Public access'
      case 'token_access':
        return 'Secure Link access'
      default:
        return 'Private access only'
    }
  }

  return (
    <Tooltip content={getShareTooltip()} showArrow>
      <Icon as={getShareIcon()} boxSize={5} mr={2} />
    </Tooltip>
  )
}

export default SharingIcon
